import './App.css';
import Home from './components/home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/login';
import ResetPassword from './components/resetPassword';
import Error404 from './components/error404';
import AdminPage from './components/Admin';
import ResetPasswordAdmin from './components/resetPasswordAdmin';
import Loginn from './components/loginn';
import Loadashboard from './components/loadashboard';
import ForgotPassword from './components/forgotPassword';
import ResetPasswordWithToken from './components/resetPasswordWithToken';

function App() {
  return (
    <Routes>
      {process.env.REACT_APP_ENVIRONMENT === 'staging' ? (
        <Route path="/" element={<Loginn />} />
      ) : (
        <Route path="/" element={<Login />} />
      )}
      <Route path="/" element={<Login />} />
      <Route path="/resetPassword" element={<ResetPassword />} />

      <Route path="/forgotPassword" element={<ForgotPassword />} />

      <Route path="/forgotPassword/reset" element={<ResetPasswordWithToken />} />

      <Route path="/home" element={<Home />} />
      <Route path="/loadashboard" element={<Loadashboard />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admin/resetPassword" element={<ResetPasswordAdmin />} />
      <Route path="*" element={<Error404 />
      } />
    </Routes>

  );
}

export default App;